/* Club model page (10.29.26): finish swatches, Complete / Build Your Own / Heads tabs, option buttons,
   gallery, and the variant id the add-to-cart form posts. Data comes from the JSON block in
   sections/model-page.liquid. The URL keeps the choice shareable: ?type=set|build|heads&finish=Black */
(function () {
  var root = document.querySelector('[data-pb-model-page]');
  if (!root) return;
  var dataEl = root.querySelector('[data-pb-im-data]');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);

  var SWATCH = {
    'Satin Chrome': '#d7dadd', 'Black': '#1c1d1f', 'Gun Metal': '#5b6065', 'Bronze': '#9a5b34', 'RAW': '#8d8a84',
    'Blonde': '#d8b47a', 'Cherry': '#8e3b26', 'Dark Walnut': '#4a2f22'
  };
  var FINISH_ORDER = ['Satin Chrome', 'Black', 'Gun Metal', 'Bronze', 'RAW', 'Blonde', 'Cherry', 'Dark Walnut'];
  var list = function (s) { return (s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); };
  var buildFinishes = list(data.buildFinishes);
  var buildSoon = list(data.buildSoon);

  var el = {
    main: root.querySelector('[data-pb-main]'),
    thumbs: root.querySelector('[data-pb-thumbs]'),
    price: root.querySelector('[data-pb-price]'),
    finishLabel: root.querySelector('[data-pb-finish-label]'),
    swatches: root.querySelector('[data-pb-swatches]'),
    tabs: root.querySelectorAll('[data-pb-tab]'),
    buy: root.querySelector('[data-pb-buy]'),
    variantInput: root.querySelector('[data-pb-variant]'),
    options: root.querySelector('[data-pb-options]'),
    config: root.querySelector('[data-pb-config]'),
    atc: root.querySelector('[data-pb-atc]'),
    stock: root.querySelector('[data-pb-stock]'),
    custom: root.querySelector('[data-pb-custom]'),
    customLink: root.querySelector('[data-pb-custom-link]'),
    soon: root.querySelector('[data-pb-soon]')
  };
  if (!el.tabs.length) return;

  var state = { type: data.defaultTab, finish: null, choices: [] };
  var defaultProduct = data.products.filter(function (p) { return p.handle === data.defaultHandle; })[0];
  if (defaultProduct) state.finish = defaultProduct.finish;

  var params = new URLSearchParams(window.location.search);
  if (params.get('type')) state.type = params.get('type') === 'custom' ? 'build' : params.get('type');
  if (params.get('finish')) state.finish = params.get('finish');

  // ---------- Data helpers ----------
  function productsOfType(type) {
    if (type === 'build') {
      // Build Your Own: the heads we sell (else the complete products), in finishes the builder offers or will again.
      var base = data.products.filter(function (p) { return p.type === 'heads'; });
      if (!base.length) base = data.products.slice();
      var allowed = buildFinishes.concat(buildSoon);
      var extra = buildSoon.filter(function (f) { return !base.some(function (p) { return p.finish === f; }); });
      base = base.concat(data.products.filter(function (p) { return extra.indexOf(p.finish) > -1 && base.indexOf(p) < 0; }));
      return buildFinishes.length ? base.filter(function (p) { return allowed.indexOf(p.finish) > -1; }) : base;
    }
    return data.products.filter(function (p) { return p.type === type; });
  }

  function finishesFor(type) {
    var seen = {};
    productsOfType(type).forEach(function (p) {
      if (!seen[p.finish]) seen[p.finish] = { finish: p.finish, available: false };
      if (type === 'build' ? buildSoon.indexOf(p.finish) < 0 : p.available) seen[p.finish].available = true;
    });
    return Object.keys(seen).map(function (k) { return seen[k]; }).sort(function (a, b) {
      var ia = FINISH_ORDER.indexOf(a.finish), ib = FINISH_ORDER.indexOf(b.finish);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
  }

  function currentProduct() {
    var l = productsOfType(state.type);
    return l.filter(function (p) { return p.finish === state.finish; })[0] || l[0];
  }

  function hasTab(type) {
    return Array.prototype.some.call(el.tabs, function (t) { return t.getAttribute('data-pb-tab') === type; });
  }

  function tabLabel(type) {
    return type === 'set' ? data.setLabel : type === 'heads' ? data.headsLabel : 'Build Your Own';
  }

  // ---------- Render ----------
  function renderTabs() {
    Array.prototype.forEach.call(el.tabs, function (t) {
      var on = t.getAttribute('data-pb-tab') === state.type;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    var build = state.type === 'build';
    el.buy.hidden = build;
    if (el.custom) el.custom.hidden = !build;
  }

  function renderSwatches() {
    var l = finishesFor(state.type);
    if (!l.some(function (f) { return f.finish === state.finish; })) {
      var firstIn = l.filter(function (f) { return f.available; })[0] || l[0];
      if (firstIn) state.finish = firstIn.finish;
    }
    el.swatches.innerHTML = '';
    l.forEach(function (f) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pb-im__swatch' + (f.available ? '' : ' is-out');
      if (SWATCH[f.finish]) {
        b.style.background = SWATCH[f.finish];
      } else {
        // No paint color for this choice (e.g. one-off Demsey drivers): show the product photo instead.
        var fp = productsOfType(state.type).filter(function (p) { return p.finish === f.finish; })[0];
        b.classList.add('pb-im__swatch--photo');
        if (fp && fp.images[0]) b.style.backgroundImage = 'url("' + fp.images[0].thumb + '")';
      }
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', f.finish === state.finish ? 'true' : 'false');
      var note = f.available ? '' : (state.type === 'build' ? ' (back soon)' : ' (sold out)');
      b.setAttribute('aria-label', f.finish + note);
      b.title = f.finish + note;
      b.addEventListener('click', function () { state.finish = f.finish; state.choices = []; state.picked = false; render(); });
      el.swatches.appendChild(b);
    });
    el.finishLabel.textContent = state.finish;
  }

  var galleryToken = 0;
  var galleryShow = null;                 // show(i) for the current gallery; used by option picks below
  function renderGallery(p) {
    galleryShow = null;
    if (!p || !p.images.length) return;
    var show = function (i) {
      var img = p.images[i];
      var token = ++galleryToken;
      if (el.main.getAttribute('src') !== img.main) {
        el.main.classList.add('is-swapping');
        var pre = new Image();
        // Only the most recent pick may swap the photo; slower earlier loads are ignored.
        pre.onload = pre.onerror = function () {
          if (token !== galleryToken) return;
          el.main.src = img.main; el.main.alt = img.alt; el.main.classList.remove('is-swapping');
        };
        pre.src = img.main;
      } else {
        el.main.classList.remove('is-swapping');
      }
      Array.prototype.forEach.call(el.thumbs.querySelectorAll('.pb-im__thumb'), function (t, ti) { t.classList.toggle('is-active', ti === i); });
    };
    el.thumbs.innerHTML = '';
    p.images.forEach(function (img, i) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pb-im__thumb';
      b.setAttribute('aria-label', 'Show image ' + (i + 1));
      b.innerHTML = '<img alt="" loading="lazy">';
      b.firstChild.src = img.thumb;
      b.addEventListener('click', function () { show(i); });
      li.appendChild(b);
      el.thumbs.appendChild(li);
    });
    galleryShow = show;
    show(0);
  }

  // Store option names -> shopper labels ("Dexterity" is hand, "Degrees" is loft).
  function optionKind(name) {
    var n = (name || '').trim();
    if (/dexterity|hand|orientation/i.test(n)) return 'hand';
    if (/degree|loft/i.test(n)) return 'loft';
    return 'other';
  }
  function optionLabel(name) {
    var k = optionKind(name);
    return k === 'hand' ? 'Hand' : k === 'loft' ? 'Loft' : name.trim();
  }
  function valueLabel(name, v) {
    var k = optionKind(name);
    if (k === 'hand') return v.replace(/ Hand$/, '');
    if (k === 'loft' && /^\d+$/.test(v)) return v + '°';
    return v;
  }

  function matchVariant(p, choices) {
    return p.variants.filter(function (v) {
      return choices.every(function (c, i) { return c == null || v.options[i] === c; });
    });
  }

  function renderOptions(p) {
    el.options.innerHTML = '';
    if (!p) return;
    var opts = p.options || [];
    var firstAvail = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    for (var i = 0; i < opts.length; i++) {
      if (state.choices[i] == null || p.variants.every(function (v) { return v.options[i] !== state.choices[i]; })) {
        state.choices[i] = firstAvail.options[i];
      }
    }
    state.choices.length = opts.length;

    var single = opts.length === 1 && opts[0] === 'Title';
    if (!single) {
      opts.forEach(function (name, i) {
        var values = [];
        p.variants.forEach(function (v) { if (values.indexOf(v.options[i]) < 0) values.push(v.options[i]); });
        var wrap = document.createElement('div');
        wrap.className = 'pb-im__opt';
        wrap.innerHTML = '<div class="pb-im__label"></div><div class="pb-im__opt-btns"></div>';
        wrap.firstChild.textContent = optionLabel(name);
        values.forEach(function (val) {
          var trial = state.choices.slice(); trial[i] = val;
          var avail = matchVariant(p, trial).some(function (v) { return v.available; });
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'pb-im__btn' + (avail ? '' : ' is-out');
          b.textContent = valueLabel(name, val);
          b.setAttribute('aria-pressed', state.choices[i] === val ? 'true' : 'false');
          if (!avail) b.setAttribute('aria-label', valueLabel(name, val) + ' (sold out)');
          b.addEventListener('click', function () { state.choices[i] = val; state.picked = true; render(); });
          wrap.lastChild.appendChild(b);
        });
        el.options.appendChild(wrap);
      });
    }

    var variant = matchVariant(p, state.choices)[0] || firstAvail;
    el.variantInput.value = variant.id;
    el.price.textContent = variant.price;
    var parts = [data.name];
    if (data.showFinish) parts.push(state.finish);
    parts.push(tabLabel(state.type));
    variant.options.forEach(function (o, i) { if (o !== 'Default Title') parts.push(valueLabel(opts[i], o)); });
    el.config.textContent = parts.join(' / ');
    el.atc.disabled = !variant.available;
    el.atc.textContent = variant.available ? (data.preorder ? 'Pre-order • ' : 'Add to cart • ') + variant.price : 'Sold out';
    el.stock.textContent = variant.available ? (data.preorder ? 'Pre-order · ' + data.preorder : 'In stock') : (p.variants.length > 1 ? 'Sold out in this configuration' : 'Sold out');
    el.stock.classList.toggle('is-out', !variant.available);
    // 11.03.26: a picked option whose variant has its own photo (e.g. Scotch Blade RAW - RH) shows that photo.
    // Only after a shopper clicks an option, so page load and tab changes look exactly as before.
    if (state.picked && galleryShow && typeof variant.img === 'number' && variant.img >= 0) galleryShow(variant.img);
  }

  function renderBuild() {
    var soon = buildSoon.indexOf(state.finish) > -1;
    var q = [];
    if (data.buildQuery) q.push(data.buildQuery.split('&').map(function (kv) {
      var parts = kv.split('=');
      return encodeURIComponent(parts[0].trim()) + '=' + encodeURIComponent((parts[1] || '').trim());
    }).join('&'));
    if (data.showFinish) q.push('finish=' + encodeURIComponent(state.finish));
    var url = data.buildUrl;
    if (q.length) url += (url.indexOf('?') < 0 ? '?' : '&') + q.join('&');
    el.customLink.href = soon ? '#' : url;
    el.customLink.classList.toggle('is-disabled', soon);
    el.customLink.setAttribute('aria-disabled', soon ? 'true' : 'false');
    el.soon.hidden = !soon;
    el.soon.textContent = soon ? state.finish + ' is back in the Custom Shop as soon as it’s restocked. Pick another finish to build now.' : '';
    // Lowest build price from the model block ("Starting at $169 · per wedge"); no price set → generic line.
    el.price.textContent = data.buildFrom
      ? 'Starting at ' + data.buildFrom + (data.buildFromNote ? ' \u00b7 ' + data.buildFromNote : '')
      : 'Built to your spec';
  }

  function syncUrl() {
    if (!window.history || !history.replaceState) return;
    var u = new URL(window.location.href);
    u.searchParams.set('type', state.type);
    if (data.showFinish) u.searchParams.set('finish', state.finish); else u.searchParams.delete('finish');
    history.replaceState(null, '', u.pathname + u.search + u.hash);
  }

  function render() {
    if (!hasTab(state.type)) state.type = el.tabs[0].getAttribute('data-pb-tab');
    renderTabs();
    renderSwatches();
    var p = currentProduct();
    renderGallery(p);
    if (state.type === 'build') renderBuild(); else renderOptions(p);
    syncUrl();
  }

  if (el.customLink) {
    el.customLink.addEventListener('click', function (evt) {
      if (el.customLink.getAttribute('aria-disabled') === 'true') evt.preventDefault();
    });
  }

  Array.prototype.forEach.call(el.tabs, function (t, i) {
    t.addEventListener('click', function () { state.type = t.getAttribute('data-pb-tab'); state.choices = []; state.picked = false; render(); });
    t.addEventListener('keydown', function (evt) {
      if (evt.key !== 'ArrowRight' && evt.key !== 'ArrowLeft') return;
      var next = el.tabs[(i + (evt.key === 'ArrowRight' ? 1 : el.tabs.length - 1)) % el.tabs.length];
      next.focus(); next.click();
    });
  });

  render();
})();
